import axios from 'axios';
import { getCurrentAccessToken } from '@/api/auth';
import { Logger } from '@/helpers/log';

const logger = new Logger('api:legacy:auth');

let accountId;
export function setAccountId(id) {
  accountId = id;
}
export async function getAuthHeader() {
  const token = await getCurrentAccessToken();
  if (!token || !accountId) {
    logger.warn('attempt to use api before auth and account set');
    return undefined;
  }
  return `${accountId}/${token}`;
}

// Setup the basic axios instance
const api = axios.create({
  timeout: 120000,
  headers: {},
});
api.interceptors.request.use(
  async (config) => {
    /* eslint-disable no-param-reassign */
    const Authorization = await getAuthHeader();
    if (!Authorization) {
      logger.warn('attempt to use api before auth');
    } else {
      config.headers.Authorization = Authorization;
    }
    return config;
    /* eslint-enable */
  },
  (error) => Promise.reject(error),
);

export default api;
